import { gql } from "lib/apolloClient";

import { configurationResponseItemFragment } from "./TeacherPortfolioFragment";

export const getConfigurationQuery = gql`
  query getConfiguration(
    $configurationEntityGroupFilters: [ConfigurationEntityGroupFilter!]
    $isAdminPage: Boolean!
    $isSettingsPage: Boolean!
  ) {
    platform {
      configuration(
        filters: {
          configurationEntityGroupFilters: $configurationEntityGroupFilters
          isSettingsPage: $isSettingsPage
        }
      ) {
        ...configurationResponseItem
        __typename
      }
      __typename
    }
  }
  ${configurationResponseItemFragment.configurationResponseItem}
`;

export const getPreferenceQuery = gql`
  query getPreference(
    $configurationEntityGroupFilters: [ConfigurationEntityGroupFilter!]
    $isAdminPage: Boolean!
  ) {
    platform {
      preferences(
        filters: {
          configurationEntityGroupFilters: $configurationEntityGroupFilters
        }
      ) {
        ...configurationResponseItem
        __typename
      }
      __typename
    }
  }
  ${configurationResponseItemFragment.preferenceResponseItem}
`;
